import React from 'react';
import { StarIcon } from 'lucide-react';
import { SHORT_QUOTES, TESTIMONIALS } from '../data/testimonials';
export function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex gap-0.5 ${className}`} aria-label="5 out of 5 stars" data-id="element-232" data-mp="3fze45yusr5w7">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-3.5 w-3.5 fill-orange text-orange" aria-hidden="true" data-id="element-233" data-mp="3b148zo92o5al" />)}
    </div>;
}
export function Testimonials() {
  return <section aria-labelledby="testimonials-title" className="w-full bg-white px-3 py-6 sm:px-5" data-id="element-234" data-mp="370ajiqfzeifl">
      <div className="mx-auto max-w-6xl" data-id="element-235" data-mp="31yl5r31djqnt">
        <div className="text-center" data-id="element-236" data-mp="2x0jlwfw4jnba">
          <h2 id="testimonials-title" className="font-head text-2xl uppercase leading-none text-navy sm:text-4xl" data-id="element-237" data-mp="2x1l0uvg9gtya">
            What families & educators are saying
          </h2>
          <p className="mt-0.5 text-[9px] font-semibold uppercase tracking-widest text-muted/70" data-id="element-238" data-mp="v9oqvq9qrs5m">
            Sample testimonials — replace with verified reviews
          </p>
        </div>

        

        <div className="mt-2 grid gap-2 lg:grid-cols-2" data-id="element-239" data-mp="h5oq3c5zm87y">
          {TESTIMONIALS.map(item => <figure key={item.name} className="flex flex-col rounded-xl border border-line bg-white p-3" data-id="element-240" data-mp="m5kkcjovulab">
              <div className="flex items-center gap-2" data-id="element-241" data-mp="78aepqyx89mi">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-navy text-[11px] font-bold text-white" data-id="element-242" data-mp="79v8vfhbpqju">
                  {item.initials}
                </span>
                <Stars data-id="element-243" data-mp="zx7sbgs6ti8x" />
              </div>
              <blockquote className="mt-1.5 text-[12px] leading-snug text-navy sm:text-[13px]" data-id="element-244" data-mp="14v99fw61z7hr">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-1.5 text-[11px] font-bold uppercase tracking-wide text-navy" data-id="element-245" data-mp="q6cvxjl8929r">
                {item.name}
                <span className="ml-1 font-medium normal-case tracking-normal text-muted" data-id="element-246" data-mp="1ivk2n5uu4y63">
                  {item.detail}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}